import React, { useContext } from "react";

import { parseStrapiImage } from "utils";
import LockedContentOverlay from "components/LockedContentOverlay";
import { CoreContext } from "context/CoreContext";
import { openLockedContentModal } from "utils/lockedContent";
import AudienceAccessIndicators from "components/AudienceAccessIndicators";
import { getContentAudiences } from "utils/audienceAccess";
import {
  CardBadge,
  CardBody,
  CardCta,
  CardDescription,
  CardImage,
  CardMeta,
  CardPlay,
  CardRoot,
  CardStats,
  CardTitle,
  CardTopline,
  ProgressBar,
  ProgressFill,
  ProgressLabel,
  StatText,
} from "./styled";

export default function LearningPathCard({ item, onAction }) {
  const { setModal } = useContext(CoreContext);
  const locked = item?.accessState === "locked";
  const image = item?.imageUrl || item?.image?.url;
  const percent = Number(item?.completionPercent || item?.progress?.completionPercent || 0);
  const clampedPercent = Math.max(0, Math.min(percent, 100));
  const courseCount = Number(item?.courseCount || 0);
  const stepCount = Number(item?.stepCount || 0);
  const itemCount = Number(item?.itemCount || courseCount || 0);
  const status = clampedPercent >= 100
    ? "Completed"
    : clampedPercent > 0
      ? "In progress"
      : "Not started";

  return (
    <CardRoot
      onClick={() => locked ? openLockedContentModal(setModal, item) : onAction?.(item?.action, item)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          locked ? openLockedContentModal(setModal, item) : onAction?.(item?.action, item);
        }
      }}
      aria-label={locked ? `${item?.title || "Learning path"}. Exclusive content` : `Open ${item?.title || "learning path"}`}
      aria-disabled={locked}
    >
      <CardImage image={image ? parseStrapiImage(image) : null}>
        <CardTopline>
          <CardBadge>{stepCount || 1} steps</CardBadge>
          <CardBadge>{itemCount} items</CardBadge>
        </CardTopline>
        <CardPlay aria-hidden="true" />
        <AudienceAccessIndicators audiences={getContentAudiences(item)} />
        {locked ? <LockedContentOverlay /> : null}
      </CardImage>
      <CardBody>
        <CardMeta>
          <ProgressLabel>{clampedPercent}% complete</ProgressLabel>
          <ProgressBar>
            <ProgressFill style={{ width: `${clampedPercent}%` }} />
          </ProgressBar>
        </CardMeta>
        <CardStats>
          <StatText>{status}</StatText>
          <StatText>{item?.completedStepCount || 0}/{item?.requiredStepCount || stepCount || 1} required</StatText>
        </CardStats>
        <CardTitle>{item?.title}</CardTitle>
        {item?.description ? <CardDescription>{item.description}</CardDescription> : null}
        <CardCta>{clampedPercent >= 100 ? "View path" : clampedPercent > 0 ? "Continue path" : "Start path"}</CardCta>
      </CardBody>
    </CardRoot>
  );
}
